// Partner bill credits are off in v1 (decision 24): cash rebates only. The pages stay; set this true together
// with PARTNER_CREDITS=on on the server to bring them back.
export const PARTNER_CREDITS = false
